"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.purchaseSatatus = exports.purchaseItemStatus = exports.STRIPE_PURCHASE_SUCCESS_REDIRECT_URL = exports.STRIPE_PURCHASE_PENDING_REDIRECT_URL = exports.STORE_PAGE = exports.STATIC_PATH = exports.SHOW_REQUEST_BILL_BUTTON = exports.PRODUCT_DETAIL_ENDPOINT = exports.PRODUCTS_PER_PAGE = exports.LOGO = exports.DISPLAY_PURCHASES_FOR_CLASSES = exports.COMMISSION_CLASS_NAME = exports.COMMISSION_BEFORE_PURCHASE_TIME = exports.COMMISSION_AFTER_PURCHASE_TIME = exports.BASE_URL = exports.BASE_APP_URL = exports.BASE_API_URL = void 0;
var _Utils = require("react-platform-components/dist/Utils");
var BASE_API_URL = (0, _Utils.getBackendConfig)('REACT_BASE_API_URL', process.env.REACT_APP_BASE_API_URL);
exports.BASE_API_URL = BASE_API_URL;
var BASE_URL = (0, _Utils.getBackendConfig)('REACT_BASE_URL', process.env.REACT_APP_BASE_URL);
exports.BASE_URL = BASE_URL;
var DISPLAY_PURCHASES_FOR_CLASSES = (0, _Utils.getBackendConfig)('DISPLAY_PURCHASES_FOR_CLASSES', process.env.REACT_APP_DISPLAY_PURCHASES_FOR_CLASSES || []);
exports.DISPLAY_PURCHASES_FOR_CLASSES = DISPLAY_PURCHASES_FOR_CLASSES;
var BASE_APP_URL = process.env.REACT_APP_BASE_APP_URL;
exports.BASE_APP_URL = BASE_APP_URL;
var PRODUCTS_PER_PAGE = process.env.REACT_APP_PRODUCTS_PER_PAGE || 9;
exports.PRODUCTS_PER_PAGE = PRODUCTS_PER_PAGE;
var STATIC_PATH = process.env.PUBLIC_URL || '';
exports.STATIC_PATH = STATIC_PATH;
var STRIPE_PURCHASE_SUCCESS_REDIRECT_URL = process.env.REACT_APP_STRIPE_PURCHASE_SUCCESS_REDIRECT_URL || '/purchase-success';
exports.STRIPE_PURCHASE_SUCCESS_REDIRECT_URL = STRIPE_PURCHASE_SUCCESS_REDIRECT_URL;
var STRIPE_PURCHASE_PENDING_REDIRECT_URL = process.env.REACT_APP_STRIPE_PURCHASE_PENDING_REDIRECT_URL || '/purchase-pending';
exports.STRIPE_PURCHASE_PENDING_REDIRECT_URL = STRIPE_PURCHASE_PENDING_REDIRECT_URL;
var LOGO = process.env.REACT_APP_LOGO_PATH || "";
exports.LOGO = LOGO;
var PRODUCT_DETAIL_ENDPOINT = process.env.REACT_APP_PRODUCT_DETAIL_ENDPOINT || "products";
exports.PRODUCT_DETAIL_ENDPOINT = PRODUCT_DETAIL_ENDPOINT;
var STORE_PAGE = process.env.REACT_APP_STORE_PAGE || "users";
exports.STORE_PAGE = STORE_PAGE;
var SHOW_REQUEST_BILL_BUTTON = process.env.REACT_APP_SHOW_REQUEST_BILL_BUTTON || false;
exports.SHOW_REQUEST_BILL_BUTTON = SHOW_REQUEST_BILL_BUTTON;
var purchaseSatatus = {
  WAITING: 'waiting',
  ASYNC_WAITING: 'async_waiting',
  ABORTED: 'aborted',
  RESERVED: 'reserved',
  CANCELLED: 'cancelled',
  FAILED: 'failed',
  FINISHED: 'finished'
};
exports.purchaseSatatus = purchaseSatatus;
var purchaseItemStatus = {
  SOLD_TO_CONFIRM: 'sold_to_confirm',
  SOLD_REFUSED_BY_SELLER: 'sold_refused_by_seller',
  SOLD_REFUSED_BY_BUYER: 'sold_refused_by_buyer',
  WAITING_FOR_EXPEDITION: 'waiting_for_expedition',
  WAITING_FOR_RECEPTION: 'waiting_for_reception',
  DELIVERED: 'delivered',
  FINISHED: 'finished'
};
exports.purchaseItemStatus = purchaseItemStatus;
var COMMISSION_CLASS_NAME = 'Commission';
exports.COMMISSION_CLASS_NAME = COMMISSION_CLASS_NAME;
var COMMISSION_BEFORE_PURCHASE_TIME = 'before_purchase';
exports.COMMISSION_BEFORE_PURCHASE_TIME = COMMISSION_BEFORE_PURCHASE_TIME;
var COMMISSION_AFTER_PURCHASE_TIME = 'after_purchase';
exports.COMMISSION_AFTER_PURCHASE_TIME = COMMISSION_AFTER_PURCHASE_TIME;